"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.starts-with");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDispatcher = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var createDispatcher = function createDispatcher() {
  var callbacks = {};

  var dispatch = function dispatch(eventName, data) {
    // Create a cloned version of the original events array
    // This is required to prevent race conditions when adding/removing event callbacks
    _toConsumableArray(callbacks[eventName] || []).forEach(function (callback) {
      callback(data);
    });
  };

  var registerEventListener = function registerEventListener(eventName, callback) {
    callbacks[eventName] = [].concat(_toConsumableArray(callbacks[eventName] || []), [callback]);
  };

  var unregisterEventListener = function unregisterEventListener(eventName, callback) {
    if (!callbacks[eventName]) return;
    callbacks[eventName] = callbacks[eventName].filter(function (cb) {
      return cb !== callback;
    });
  };

  var unregisterAllFeatureEventListeners = function unregisterAllFeatureEventListeners(frameId) {
    callbacks = Object.keys(callbacks).reduce(function (updatedCallbacks, eventName) {
      if (!eventName.startsWith(frameId)) {
        updatedCallbacks[eventName] = callbacks[eventName];
      }

      return updatedCallbacks;
    }, {});
  };

  return {
    dispatch: dispatch,
    registerEventListener: registerEventListener,
    unregisterEventListener: unregisterEventListener,
    unregisterAllFeatureEventListeners: unregisterAllFeatureEventListeners
  };
};

exports.createDispatcher = createDispatcher;